import { Immutable } from "immer";
import React from "react";
import { FinancingModalTrigger } from "tsi-common-react/src/apps/financing/FinancingModalTrigger";
import { Link } from "tsi-common-react/src/components/Link/index";
import { getDefaultFinancingPlan } from "tsi-common-react/src/utils/financing";
import { formatFinancingPlan } from "tsi-common-react/src/utils/format";
import { usePageURL, useStaticURL } from "tsi-common-react/src/utils/urls";
import { c, t } from "ttag";

import styles from "./index.module.scss";

type IProps = Immutable<{
    applicationSource?: string;
}>;

export const FinancingBannerBlock = (props: IProps) => {
    const plan = formatFinancingPlan(getDefaultFinancingPlan());
    const financeLink = usePageURL("finance_link");
    const staticURL = useStaticURL();
    return (
        <div className={styles.root}>
            <div className={styles.rootBlockContainer}>
                <img
                    className={styles.financingBlockImage}
                    alt={t`Stearns and Foster Credit Card`}
                    src={`${staticURL}img/finance/stearns-cc_large.png`}
                    loading="lazy"
                    decoding="async"
                />
                <div className={styles.financingBlockTerms}>
                    <h5>
                        {c("FinancingBannerBlock")
                            .t`${plan.apr} APR for ${plan.length} Months`}
                        <sup>
                            <Link href={financeLink}>
                                {plan.superscript}
                                <span className="ada-screenreader-only">
                                    {t`Additional information about Terms and Conditions`}
                                </span>
                            </Link>
                        </sup>
                    </h5>
                    <div className={styles.financingBlockThreshold}>
                        {t`with minimum purchase of ${plan.threshold}`}
                    </div>
                    <ul className={styles.financingBlockTermsLine}>
                        <li>
                            {t`No Annual Fee`}
                            <sup>
                                <Link href={financeLink}>
                                    {plan.superscript}
                                    <span className="ada-screenreader-only">
                                        {t`Additional information about Terms and Conditions`}
                                    </span>
                                </Link>
                            </sup>
                        </li>
                        <li>
                            {t`Pre-qualify without impacting your credit score`}
                        </li>

                        <li>{t`Apply now or during checkout`}</li>
                    </ul>
                </div>

                <FinancingModalTrigger
                    modalType="prequal-app"
                    className={`button button--secondary ${styles.preQualifyButton}`}
                    applicationSource={props.applicationSource}
                >
                    {t`Check If You Pre-Qualify`}
                </FinancingModalTrigger>
                <FinancingModalTrigger
                    modalType="full-app"
                    className="button"
                    applicationSource={props.applicationSource}
                >
                    {t`Apply Now`}
                </FinancingModalTrigger>
            </div>
        </div>
    );
};
